import { render, staticRenderFns } from "./SubmissionStatePage.vue?vue&type=template&id=1adeac45&scoped=true"
import script from "./SubmissionStatePage.vue?vue&type=script&lang=js"
export * from "./SubmissionStatePage.vue?vue&type=script&lang=js"
import style0 from "./SubmissionStatePage.vue?vue&type=style&index=0&id=1adeac45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adeac45",
  null
  
)

export default component.exports